import {createApp} from 'vue'
import SearchPage from './SearchPage.vue'

document.addEventListener('DOMContentLoaded', () => {
    const searchContainer = document.getElementById('search-page')

    if(searchContainer) {
        const app = createApp({})

        app.component('search-page', SearchPage)
        app.mount('#search-page')
    }
})